// Recognize the existing, standalone reading-order instruction in each edition.
// This also repairs presentation of older cached books without changing their
// words, block IDs, or the location of the instruction within the chapter.
const normalize=text=>text.normalize('NFKC').replace(/[\s!¡。.：:]/gu,'').toUpperCase();
const warnings=new Set([
  'DO NOT JUMP CHAPTERS',
  'ÜBERSPRINGE KEINE KAPITEL',
  'NON SALTARE I PARAGRAFI',
  'HOPPA INTE ÖVER NÅGRA KAPITEL',
  'НЕ ПЕРЕПРЫГИВАЙТЕ ЧЕРЕЗ ГЛАВЫ',
  'HA CUTUB-BOODIN',
  'NU TRECETI PESTE CAPITOLE',
  'MOS ANASHKALONI KAPITUJT',
  'SLA GEEN HOOFDSTUKKEN OVER!',
  'NÃO PULE CAPÍTULOS',
  'CZYTAJ PO KOLEI',
  '챕터를 건너뛰지 마세요',
  'НЕ ПРОПУСКАЙТЕ РОЗДІЛИ',
  'सारे Chapters पढ़ना, स्किप मत करना',
  '章を飛ばしてはいけない',
  '¡NO TE SALTES NINGÚN CAPÍTULO!',
  'ال تتخطَّ الفصول',
  'لا تتخطَّ الفصول',
  'NEPŘESKAKUJETE KAPITOLY',
  'هشدار : كتاب را با ترتيبي كه نوشته شده است بخوانيد.',
  'NE SAUTEZ PAS LES CHAPITRES',
  'NE UGORJ ÁT EGY FEJEZETET SE!',
  'BÖLÜMLERİ ATLAMAYIN !',
].map(normalize));

export function chapterWarnings(html){
  return html.replace(/<(p|h[2-6])\b([^>]*)>([\s\S]*?)<\/\1\s*>/gi,(original,tag,attributes,content)=>{
    if(content.includes('chapter-order-warning'))return original;
    const text=content.replace(/<[^>]*>/g,'');
    if(!warnings.has(normalize(text)))return original;
    return `<${tag}${attributes}><strong class="chapter-order-warning">${content}</strong></${tag}>`;
  });
}
